import { MedicalCase } from '../../../domain/medical-case/model/medical-case';
import { MedicalCaseProcessedContent } from '../../../domain/medical-case/model';
import {
  MedicalCasePipelineFlow,
  PreparationStepKey,
  StepProcessingStatus,
} from '../model/pipeline-step.model';

export namespace MedicalCasePipelineStepActions {
  const prefix = '[MedicalCasePipelineStep]';

  export class Initialize {
    static readonly type = `${prefix} Initialize`;

    constructor(
      readonly caseId: string,
      readonly flow: MedicalCasePipelineFlow,
      readonly initialCaseDetail?: MedicalCase | null
    ) {}
  }

  export class StartPolling {
    static readonly type = `${prefix} StartPolling`;
  }

  export class StopPolling {
    static readonly type = `${prefix} StopPolling`;
  }

  export class MarkStepCompleted {
    static readonly type = `${prefix} MarkStepCompleted`;

    constructor(readonly step: PreparationStepKey) {}
  }

  export class ResetStep {
    static readonly type = `${prefix} ResetStep`;

    constructor(readonly step: PreparationStepKey) {}
  }

  export class SetBackendProcessing {
    static readonly type = `${prefix} SetBackendProcessing`;

    constructor(readonly processing: boolean) {}
  }

  export class SetProcessingError {
    static readonly type = `${prefix} SetProcessingError`;

    constructor(readonly error: string | null) {}
  }

  export class SetProcessingStep {
    static readonly type = `${prefix} SetProcessingStep`;

    constructor(readonly step: PreparationStepKey | null) {}
  }

  export class SetStepProcessing {
    static readonly type = `${prefix} SetStepProcessing`;

    constructor(
      readonly step: PreparationStepKey,
      readonly status: StepProcessingStatus
    ) {}
  }

  export class SetSubmittedOriginalDocumentIds {
    static readonly type = `${prefix} SetSubmittedOriginalDocumentIds`;

    constructor(
      readonly step: PreparationStepKey,
      readonly originalDocumentIds: string[]
    ) {}
  }

  export class UpdateProcessingStatuses {
    static readonly type = `${prefix} UpdateProcessingStatuses`;

    constructor(readonly medicalCase: MedicalCase) {}
  }

  export class FetchStepContent {
    static readonly type = `${prefix} FetchStepContent`;

    constructor(
      readonly step: PreparationStepKey,
      readonly fileIds: string[]
    ) {}
  }

  export class StoreStepContent {
    static readonly type = `${prefix} StoreStepContent`;

    constructor(
      readonly step: PreparationStepKey,
      readonly content: MedicalCaseProcessedContent
    ) {}
  }

  export class UpdateFromBackend {
    static readonly type = `${prefix} UpdateFromBackend`;

    constructor(readonly medicalCase: MedicalCase) {}
  }

  export class ResetState {
    static readonly type = `${prefix} ResetState`;
  }
}
